module.exports = __webpack_public_path__ + "e1f74dd125c945ded01a0cd7ce91e101.pdf";